module.exports = __webpack_public_path__ + "static/media/18_AnnelieHegemann_webfinal.7f700c04.jpg";